import { TaskError, TaskStatus } from '@nexelem/graphne-api';
import { useCustomTranslation } from '../../../../hooks';
import { hasCriticalError } from './hasCriticalError';

export const useTaskStatusTranslation = () => {
  const { t, tWrapper } = useCustomTranslation('productionLots.productionLotsViewStatuses');
  return (status: TaskStatus, errors?: TaskError[]): string => {
    const criticalError = hasCriticalError(errors);

    if (criticalError) {
      return t('common.error');
    }

    switch (status) {
      case TaskStatus.Cancelled:
        return tWrapper('cancelled');
      case TaskStatus.Completed:
        return tWrapper('inWarehouse');
      case TaskStatus.Error:
        return t('common.error');
      case TaskStatus.InProgress:
        return tWrapper('inProduction');
      case TaskStatus.NotPlanned:
        return tWrapper('toSpec');
      case TaskStatus.Pending:
        return tWrapper('planned');
      default:
        return 'Unknown status';
    }
  };
};
